/**
 * SectionCard — 섹션 카드 (v2 목업 `.sec-h` + `.card`).
 *
 * 순수 프레젠테이션. v2(2026-09-21): 흰 카드 · radius 16 · --ca-sh-card, 테두리 없음.
 * 제목 18px/700 + (선택) 오렌지 아이콘. 제목이 없으면 헤더를 생략한다.
 */

import React from 'react';

export interface SectionCardProps {
  title?: string;
  /** 제목 왼쪽 아이콘 (v2 .sec-h .ttl .ms — 오렌지) */
  icon?: React.ReactNode;
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export function SectionCard({ title, icon, action, children, className = '' }: SectionCardProps) {
  return (
    <section className={`overflow-hidden rounded-ca-3xl bg-frame shadow-ca-card ${className}`}>
      {title && (
        <header className="flex items-center justify-between gap-2 px-4 pb-2.5 pt-4">
          <h2 className="flex items-center gap-1.5 text-[18px] font-bold leading-[26px] tracking-[-0.015em] text-ink">
            {icon && <span className="flex shrink-0 text-accent">{icon}</span>}
            {title}
          </h2>
          {action && <div className="flex-shrink-0">{action}</div>}
        </header>
      )}
      <div className={`px-4 pb-4 ${title ? '' : 'pt-4'}`}>{children}</div>
    </section>
  );
}

export default SectionCard;
